import Seo from "../Components/Seo";
import { buildvideosDescription, buildvideosJsonLd, buildvideosKeywords } from "../utils/VideoSeo";

type videosSeoProps = {
  videos: any;
  canonicalPath: string;
};

const VideoSeo = ({ videos, canonicalPath }: videosSeoProps) => {
    debugger;
  if (!videos) return null;

  const title = videos?.pageTitle || videos?.ogTitle || (videos?.name ? `${videos.name} | Gita Seva` : "Gita Seva videos");
  const description = videos?.pageDescription || videos?.ogDescription || buildvideosDescription(videos);
  const keywords = buildvideosKeywords(videos);
  const image = videos?.ogImage || videos?.videosPath || "";
  const jsonLd = buildvideosJsonLd(videos, canonicalPath);

  return (
    <Seo
      title={title}
      description={description}
      keywords={keywords}
      path={canonicalPath}
      image={image}
      ogImageWidth={1200}
      ogImageHeight={630}
      ogType="videos"
      robots="index,follow"
      jsonLd={jsonLd}
    />
  );
};

export default VideoSeo;






